export default __webpack_public_path__ + "static/media/playngo.ce09b4c0.svg";